import * as React from "react";
import { Form, Upload, Button, Icon, Select } from "antd";
import { FormVersionDocumentFormConstants } from "../../../../common/Constants";
import { IReportingPeriodApplicantDocument } from "../../../../model/document/ReportingPeriodApplicantDocument";

const ReportingPeriodApplicantDocumentForm = ({
  getFieldDecorator,
  translate,
  formVersionDocument,
  allowedFileTypes
}: {
  getFieldDecorator: any;
  translate: any;
  formVersionDocument?: IReportingPeriodApplicantDocument;
  allowedFileTypes?: string;
}) => {
  function normFile(e) {
    if (Array.isArray(e)) {
      return e;
    }
    if (e.fileList.length > 1) {
      e.fileList.shift();
    }
    return e && e.fileList;
  }
  return (
    <Form>
      <Form.Item label={translate("form_version_document_form.documentLink")}>
        {getFieldDecorator(
          FormVersionDocumentFormConstants.FIELDS.DOCUMENT_RELATION,
          {
            initialValue:
              formVersionDocument && formVersionDocument.documentRelation,
            rules: [
              {
                required: formVersionDocument ? false : true,
                message: translate(
                  "form_version_document_form.required_message",
                  {
                    field: translate("form_version_document_form.documentLink")
                  }
                )
              }
            ]
          }
        )(
          <Select
            disabled={formVersionDocument ? true : false}
            placeholder={translate("form_version_document_form.documentLink")}
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          >
            {FormVersionDocumentFormConstants.DOCUMENT_LINK_VALUES_AS_ARRAY.map(
              (documentLinkValue) => (
                <Select.Option key={documentLinkValue}>
                  {translate(
                    `form_version_document_form.document_link_values.${documentLinkValue}`
                  )}
                </Select.Option>
              )
            )}
          </Select>
        )}
      </Form.Item>
      <Form.Item label={translate("form_version_document_form.document")}>
        {getFieldDecorator(FormVersionDocumentFormConstants.FIELDS.DOCUMENT, {
          initialValue: formVersionDocument && formVersionDocument.document,
          valuePropName: "fileList",
          getValueFromEvent: normFile,
          rules: [
            {
              required: true,
              message: translate(
                "form_version_document_form.required_message",
                {
                  field: translate("form_version_document_form.document")
                }
              )
            }
          ]
        })(
          <Upload
            beforeUpload={(file) => {
              return false;
            }}
            accept={allowedFileTypes ?? "*.*"}
          >
            <Button>
              <Icon type="upload" />
              {translate("form_version_document_form.select_document")}
            </Button>
          </Upload>
        )}
      </Form.Item>
    </Form>
  );
};

export default ReportingPeriodApplicantDocumentForm;
